import Image from "next/image";
import styles from "./DownloadNH.module.css";

function PhoneIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect
        x="7"
        y="2.5"
        width="10"
        height="19"
        rx="2.2"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path d="M11 18.5h2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export default function DownloadNH() {
  return (
    <div className={`${styles.root} standard-padding`}>
      <section className={styles.section} aria-labelledby="download-nh-title">
        <img
          src="/assets/images/App-QR-Code.webp"
          alt=""
          className={styles.bgImage}
          aria-hidden="true"
        />

        <div className={styles.content}>
          <span className={styles.badge}>
            <PhoneIcon />
            Download Next Holidays App
          </span>

          <h2 id="download-nh-title" className={styles.title}>
            Your Whole Trip, <em>in Your Pocket</em>
          </h2>

          <p className={styles.desc}>
            Book flights, hotels, and experiences on the go. Get exclusive
            app-only deals and real-time updates.
          </p>

          <div className={styles.stores}>
            <a
              href="https://play.google.com/store/apps/details?id=com.app.nextholidays"
              className={styles.storeLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
            >
              <Image
                src="/assets/images/playstore.png"
                alt="Get it on Google Play"
                width={160}
                height={48}
                className={styles.storeImg}
                quality={70}
                loading="lazy"
              />
            </a>
            <a
              href="https://apps.apple.com/us/app/next-holidays/id6749560329"
              className={styles.storeLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Apple Store"
            >
              <Image
                src="/assets/images/applestore.png"
                alt="Get it on Apple Store"
                width={160}
                height={48}
                className={styles.storeImg}
                quality={70}
                loading="lazy"
              />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
